'use strict';

var dateFns = require('date-fns');
var parseISOTimeIntervalToMilliseconds = require('./parseISOTimeIntervalToMilliseconds.cjs');

const parseISOTimeIntervalToMinutes = (unorderedInterval) => {
  const intervalInMilliseconds = parseISOTimeIntervalToMilliseconds(unorderedInterval);
  return dateFns.millisecondsToMinutes(intervalInMilliseconds);
};

module.exports = parseISOTimeIntervalToMinutes;
//# sourceMappingURL=parseISOTimeIntervalToMinutes.cjs.map
